import { render, staticRenderFns } from "./resolvePop.vue?vue&type=template&id=58da8f46&scoped=true&"
import script from "./resolvePop.vue?vue&type=script&lang=js&"
export * from "./resolvePop.vue?vue&type=script&lang=js&"
import style0 from "./resolvePop.vue?vue&type=style&index=0&id=58da8f46&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58da8f46",
  null
  
)

export default component.exports